enum SupportFields {
	CONFIG = "config",
	INIT = "init",
	LOGS = "logs",
	START = "start",
	END = "end"
}

export default SupportFields;